import { required } from '@bpba/form-components';
import { EMAIL_PATTERN, INPUT_INVALID_FORMAT_MESSAGE } from '../../constants/form';

const emailValidation = {
  message: INPUT_INVALID_FORMAT_MESSAGE,
  value: EMAIL_PATTERN,
};

export const LoginRules = {
  rules: {
    email: { required, pattern: emailValidation },
  },
};
